import { stripMarkdownSyntax } from "@thegetty-private/getty-ui";

/**
 * This transforms markdown to text AND unescapes common html entities with character entities (i.e. "&amp" -> "&")
 *
 * @param {string} value - the original text value
 *
 * @returns {string}
 */
export function unescapeHtmlAndTransformMarkdown(value) {
  if (value == undefined) {
    return undefined;
  }

  return stripMarkdownSyntax(value, {
    htmlEntities: false,
    escapeHtml: false
  });
}
